import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3e335f33 = () => interopDefault(import('..\\pages\\coming-soon\\index.vue' /* webpackChunkName: "pages_coming-soon_index" */))
const _9ea98488 = () => interopDefault(import('..\\pages\\dashboard.vue' /* webpackChunkName: "pages_dashboard" */))
const _c6c89ea6 = () => interopDefault(import('..\\pages\\eligibility\\index.vue' /* webpackChunkName: "pages_eligibility_index" */))
const _10c81330 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _05cc08ab = () => interopDefault(import('..\\pages\\settings.vue' /* webpackChunkName: "pages_settings" */))
const _761acf4c = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _2750b400 = () => interopDefault(import('..\\pages\\account\\forgot-password.vue' /* webpackChunkName: "pages_account_forgot-password" */))
const _3d1d0124 = () => interopDefault(import('..\\pages\\account\\login.vue' /* webpackChunkName: "pages_account_login" */))
const _c2de243e = () => interopDefault(import('..\\pages\\account\\my-account.vue' /* webpackChunkName: "pages_account_my-account" */))
const _dece5590 = () => interopDefault(import('..\\pages\\account\\register.vue' /* webpackChunkName: "pages_account_register" */))
const _82d46524 = () => interopDefault(import('..\\pages\\account\\register-success.vue' /* webpackChunkName: "pages_account_register-success" */))
const _06f999a4 = () => interopDefault(import('..\\pages\\account\\reset-password.vue' /* webpackChunkName: "pages_account_reset-password" */))
const _a09e338a = () => interopDefault(import('..\\pages\\claim\\search-claim.vue' /* webpackChunkName: "pages_claim_search-claim" */))
const _a0cf16aa = () => interopDefault(import('..\\pages\\claim\\submit-claim.vue' /* webpackChunkName: "pages_claim_submit-claim" */))
const _394c1736 = () => interopDefault(import('..\\pages\\claim\\upload.vue' /* webpackChunkName: "pages_claim_upload" */))
const _18e6aa50 = () => interopDefault(import('..\\pages\\enrollment\\form.vue' /* webpackChunkName: "pages_enrollment_form" */))
const _4e9fff88 = () => interopDefault(import('..\\pages\\enrollment\\patient-information.vue' /* webpackChunkName: "pages_enrollment_patient-information" */))
const _729b5ad8 = () => interopDefault(import('..\\pages\\enrollment\\payer-information.vue' /* webpackChunkName: "pages_enrollment_payer-information" */))
const _18690886 = () => interopDefault(import('..\\pages\\enrollment\\pending-enrollment.vue' /* webpackChunkName: "pages_enrollment_pending-enrollment" */))
const _6c9f5090 = () => interopDefault(import('..\\pages\\enrollment\\prescriber-hub-information.vue' /* webpackChunkName: "pages_enrollment_prescriber-hub-information" */))
const _9452dae0 = () => interopDefault(import('..\\pages\\enrollment\\prescriber-information.vue' /* webpackChunkName: "pages_enrollment_prescriber-information" */))
const _b51c90b2 = () => interopDefault(import('..\\pages\\enrollment\\success.vue' /* webpackChunkName: "pages_enrollment_success" */))
const _0025a1f2 = () => interopDefault(import('..\\pages\\enrollment\\success-modal.vue' /* webpackChunkName: "pages_enrollment_success-modal" */))
const _34c625d1 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _34d43d52 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _34f06c54 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _34fe83d5 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _69ac6112 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _3618fa7c = () => interopDefault(import('..\\pages\\patient-information\\patient-search.vue' /* webpackChunkName: "pages_patient-information_patient-search" */))
const _65fc160c = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/coming-soon",
    component: _3e335f33,
    name: "coming-soon"
  }, {
    path: "/dashboard",
    component: _9ea98488,
    name: "dashboard"
  }, {
    path: "/eligibility",
    component: _c6c89ea6,
    name: "eligibility"
  }, {
    path: "/error",
    component: _10c81330,
    name: "error"
  }, {
    path: "/settings",
    component: _05cc08ab,
    name: "settings"
  }, {
    path: "/unlock",
    component: _761acf4c,
    name: "unlock"
  }, {
    path: "/account/forgot-password",
    component: _2750b400,
    name: "account-forgot-password"
  }, {
    path: "/account/login",
    component: _3d1d0124,
    name: "account-login"
  }, {
    path: "/account/my-account",
    component: _c2de243e,
    name: "account-my-account"
  }, {
    path: "/account/register",
    component: _dece5590,
    name: "account-register"
  }, {
    path: "/account/register-success",
    component: _82d46524,
    name: "account-register-success"
  }, {
    path: "/account/reset-password",
    component: _06f999a4,
    name: "account-reset-password"
  }, {
    path: "/claim/search-claim",
    component: _a09e338a,
    name: "claim-search-claim"
  }, {
    path: "/claim/submit-claim",
    component: _a0cf16aa,
    name: "claim-submit-claim"
  }, {
    path: "/claim/upload",
    component: _394c1736,
    name: "claim-upload"
  }, {
    path: "/enrollment/form",
    component: _18e6aa50,
    name: "enrollment-form"
  }, {
    path: "/enrollment/patient-information",
    component: _4e9fff88,
    name: "enrollment-patient-information"
  }, {
    path: "/enrollment/payer-information",
    component: _729b5ad8,
    name: "enrollment-payer-information"
  }, {
    path: "/enrollment/pending-enrollment",
    component: _18690886,
    name: "enrollment-pending-enrollment"
  }, {
    path: "/enrollment/prescriber-hub-information",
    component: _6c9f5090,
    name: "enrollment-prescriber-hub-information"
  }, {
    path: "/enrollment/prescriber-information",
    component: _9452dae0,
    name: "enrollment-prescriber-information"
  }, {
    path: "/enrollment/success",
    component: _b51c90b2,
    name: "enrollment-success"
  }, {
    path: "/enrollment/success-modal",
    component: _0025a1f2,
    name: "enrollment-success-modal"
  }, {
    path: "/errors/400",
    component: _34c625d1,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _34d43d52,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _34f06c54,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _34fe83d5,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _69ac6112,
    name: "errors-500"
  }, {
    path: "/patient-information/patient-search",
    component: _3618fa7c,
    name: "patient-information-patient-search"
  }, {
    path: "/",
    component: _65fc160c,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
